import { TabularMeta_User } from '__generated__/TabularMeta_User';
import { DesignerSource } from '__generated__/types';
import Icon from 'launch/components/Icon';
import DesignerLevel from 'projects/components/DesignerLevel';
import * as React from 'react';
import AddDesignerButton from './AddDesignerButton';
import Avatar from './Avatar';

export interface Props {
    designer: TabularMeta_User;
    brief: { id: string; designers: { id: number }[] };
}

const ContactMeta = ({ designer, brief }: Props) => {
    return (
        <div className="contact-meta">
            <div className="contact-meta__avatar">
                <Avatar userId={designer.id} variations={['medium']} />
            </div>
            <div className="contact-meta__name">
                <div className="paragraph paragraph--text paragraph--regular paragraph--no-margin">
                    {designer.displayName}
                </div>
                <div className="contact-meta__rating">
                    {designer.profile.review.rating}
                    <Icon icon="star-2" offsetLeft={true} />
                </div>
            </div>
            <div className="contact-meta__level">
                <DesignerLevel level={designer.profile.designerLevel} />
            </div>
            <div className="contact-meta__icons">
                {designer.profile.isContact && (
                    <Icon icon="contacts-1" offsetLeft={true} size={'large'} />
                )}
                {designer.profile.isFavorite && (
                    <Icon icon="heart-1" offsetLeft={true} highlight={true} />
                )}
            </div>
            <div className="contact-meta__cta">
                <AddDesignerButton designer={designer} designerSource={DesignerSource.CONTACT} />
            </div>
        </div>
    );
};

export default ContactMeta;
